/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type View = "ADD_EMAIL_ADDRESS" | "CREATE_PASSWORD" | "CREATE_USERNAME" | "FORGOT_PASSWORD" | "LINK_ACCOUNT" | "SIGN_IN" | "SIGN_UP" | "%future added value";
export type AppQueryLocal = {
    readonly view: View;
    readonly " $refType": "AppQueryLocal";
};
export type AppQueryLocal$data = AppQueryLocal;
export type AppQueryLocal$key = {
    readonly " $data"?: AppQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"AppQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "view",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'bf994afd5bfa17e5f7387360af904026';
export default node;
